import { render } from "./cte-editar-nova.vue?vue&type=template&id=8d6b6c7c"
import script from "./cte-editar-nova.vue?vue&type=script&lang=js"
export * from "./cte-editar-nova.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__